import Grid from '@mui/material/Unstable_Grid2/Grid2'
import DisplayData from './DisplayData/DisplayData'
import relogio from '../../Assets/icones/relogio.svg'
import bateriaHorizontal from '../../Assets/icones/bateria-horizontal.svg'
import temperatura from '../../Assets/icones/temperatura.svg'
import wattimetro from '../../Assets/icones/wattimetro.svg'
import tomada from '../../Assets/icones/tomada.svg'
import pilhaVertical from '../../Assets/icones/pilha-vertical.svg'
import tomadaParede from '../../Assets/icones/tomada-parede.svg'
import { Box, Typography, Tab, Tabs } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { WebSocketContext } from '../../Providers/WebSocket/WebSocketContext'
import { CondominiosContext } from '../../Providers/CondominiosContext/CondominiosContext'
import FigmaTable from '../FigmaTable/FigmaTable'
import { formatDateTime } from '../../Utils/Utils'

const Nobreak = () => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { activeCond } = useContext(CondominiosContext)
    const [selectedTab, setSelectedTab] = useState(0) // Aba selecionada

    const [dadosNobreak, setDadosNobreak] = useState([])
    const [historicoNobreak, setHistoricoNobreak] = useState([])

    const getDados = (msg) => {
        if (msg.data.status) {
            // const nobreakArray = msg.data.nobreak.dados || [];
            const nobreaks = msg.data.nobreak.map(item => ({
                ...item.dados,
                id: item.id,
                tipo: item.tipo
            }))
            // setHistoricoNobreak(msg.data.nobreak.historico)
            setHistoricoNobreak(msg.data.nobreak.map(item => item.historico))
            setDadosNobreak(nobreaks)
        } else {
            setHistoricoNobreak([])
            setDadosNobreak([])
        }
    }

    const columns = [
        {
            name: 'Evento',
            cell: row => row.descricao ? `${row.descricao}` : "",
            style: {
                width: '70%'
            }
        },
        {
            name: 'Data',
            cell: row => row.data ? formatDateTime(row.data) : "",
            style: {
                width: '30%'
            }
        }
    ]

    addRoute('getInfoNobreak', getDados)

    const attDados = () => {
        sendWs('getInfoNobreak', { filtros: { id_central: activeCond.id_central } })
    }
    useEffect(() => {
        sendWs('getInfoNobreak', { filtros: { id_central: activeCond.id_central } })
        const interval = setInterval(() => {
            attDados()
        }, 5000)
        return () => clearInterval(interval)
    }, [])

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue)
    }

    const porcentagemBateria = (index) => {
        if (dadosNobreak[index]['Porcentagem Bateria']) {
            let porcentagem = `${Math.min((parseFloat((dadosNobreak[index]['Porcentagem Bateria'] || '0%').replace('%', '')) * (35 / 100)), 35)}%`
            return porcentagem
        } else {
            return 0
        }
    }

    const tempoBateria = (index) => {
        if (dadosNobreak[index]['Tempo operando pela Bateria']) {
            let tempo = dadosNobreak[index]['Tempo operando pela Bateria'].split(":")
            let tempoFormatado = tempo.map((item) => {
                if (item.length === 1) {
                    return `0${item}`
                } else {
                    return item
                }
            })
            return tempoFormatado.join(":")
        } else {
            return "00:00:00"
        }
    }

    return (
        <Grid
            container
            sx={{
                height: '100%',
                width: '100%',
                backgroundColor: '#D9D9D9',
                borderRadius: '5px',
                padding: '5px',
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                justifyContent: 'center',
                overflow: 'hidden'
            }}
            gap={0.5}
        >
            {dadosNobreak.length > 0
                ? (
                    <>
                        <Grid item xs={12}>
                            <Tabs value={selectedTab} onChange={handleTabChange} centered>
                                {dadosNobreak.map((nobreak, index) => (
                                    <Tab key={index} label={nobreak.tipo === 43
                                        ? `Nobreak Intelbras`
                                        : nobreak.tipo === 27
                                            ? `Nobreak Engmoura`
                                            : `Nobreak ${index + 1}`
                                    } />
                                ))}
                            </Tabs>
                        </Grid>

                        {dadosNobreak.map((dadosNobreak, index) => (
                            <Grid
                                container
                                key={index}
                                sx={{
                                    display: selectedTab === index ? 'flex' : 'none',
                                    height: '100%',
                                    width: '100%',
                                    borderRadius: '5px',
                                    padding: '45px',
                                    justifyContent: 'center'
                                }} gap={0.5}
                            >
                                {/* Primeira Coluna */}
                                <Grid container item
                                    sx={{
                                        width: '25%',
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        alignContent: 'center'
                                    }} >
                                    <Grid item sx={{ width: '100%', height: '33%' }}>
                                        <DisplayData
                                            icone={relogio}
                                            descricao="Tempo na Bateria"
                                            valor={tempoBateria([index]) || ""}
                                        />
                                    </Grid>
                                    <Grid item sx={{ width: '100%', height: '33%' }}>
                                        <DisplayData
                                            icone={temperatura}
                                            descricao="Temperatura"
                                            valor={dadosNobreak.Temperatura}
                                        />
                                    </Grid>
                                    <Grid item sx={{ width: '100%', height: '33%' }}>
                                        <DisplayData
                                            icone={tomada}
                                            descricao="Tensão Entrada"
                                            valor={dadosNobreak['Tensão Entrada']}
                                        />
                                    </Grid>
                                </Grid>

                                {/* Coluna Central */}
                                <Grid container item sx={{
                                    width: '48%',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    alignContent: 'center'
                                }} >
                                    <Grid container sx={{ height: '15%', width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                                        <Typography fontSize={"40px"} fontWeight="600" textAlign="center" color="#590CFB">No-Break</Typography>
                                    </Grid>
                                    <Grid container sx={{ height: '40%', width: '100%', position: 'relative' }}>
                                        <Grid sx={{
                                            height: '80%',
                                            width: '100%',
                                            backgroundImage: `url(${bateriaHorizontal})`,
                                            backgroundSize: 'contain',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPositionX: 'center'
                                        }}>
                                            <Box sx={{
                                                backgroundColor: '#0FBB00',
                                                borderRadius: '5px',
                                                width: `${porcentagemBateria(index)}`,
                                                // width: `${Math.min((parseFloat((dadosNobreak['Porcentagem Bateria'] || '0%').replace('%', '')) * (35 / 100)), 35)}%`,
                                                height: '40%',
                                                marginTop: '10%',
                                                marginLeft: '31%'
                                            }} ></Box>

                                        </Grid>
                                        {}
                                        <Grid sx={{ width: '100%' }}>
                                            <Typography fontSize="31px" fontWeight="600" textAlign="center" color="#590CFB">{dadosNobreak['Porcentagem Bateria']}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container sx={{ height: '40%' }}>
                                        <Typography fontSize="16px" fontWeight="600" textAlign="center">Histórico Eventos</Typography>
                                        <Grid container sx={{ height: '80%', width: '100%' }}>
                                            <FigmaTable data={historicoNobreak[index] || []} columns={columns} />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* Terceira Coluna */}
                                <Grid container item sx={{
                                    width: '25%',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    alignContent: 'center'
                                }} >
                                    <Grid item sx={{ width: '100%', height: '33%' }}>
                                        <DisplayData
                                            icone={pilhaVertical}
                                            descricao="Tensão Baterias"
                                            valor={dadosNobreak['Tensão Baterias']}
                                        />
                                    </Grid>
                                    <Grid item sx={{ width: '100%', height: '33%' }}>
                                        <DisplayData
                                            icone={wattimetro}
                                            descricao="Potência Saída"
                                            valor={dadosNobreak['Potência saída fase 1']}
                                        />
                                    </Grid>
                                    <Grid item sx={{ width: '100%', height: '33%' }}>
                                        <DisplayData
                                            icone={tomadaParede}
                                            descricao="Tensão Saída"
                                            valor={dadosNobreak['Tensão Saída']}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}
                    </>
                )
                : (
                    <Typography fontSize="16px" fontWeight="600" textAlign="center">
                    Sem dados de nobreak para exibir
                    </Typography>
                )}
        </Grid>
    )
}

export default Nobreak
